import { apiSlice } from './apiSlice';

export const tradeHistoryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * `GET /<login>/trade-history/` — one account's trade history, a page at a
     * time (it replaced `/my-alpha/<login>/trade-history/`). Takes the
     * platform, `page` / `page_size`, `search`, `filter` and
     * `start_date` / `end_date`.
     *
     * `{ count, next, previous, page_number, page_size, results }`, one row per
     * closed position whatever the platform: `position_id`, `symbol`, `side`,
     * `volume`, `open_price` / `close_price`, `open_time` / `close_time` (broker
     * time) and their `_utc` twins, `profit`, `commission`, `swap`,
     * `net_profit`, `stop_loss`, `take_profit`, `opened_via`, `is_ea`,
     * `exit_reason`, `partial_history`, `platform`.
     */
    getTradeHistory: builder.query({
      query: ({ loginId, ...params }) => ({
        url: `/${encodeURIComponent(loginId)}/trade-history/`,
        params,
      }),
      providesTags: ['Trade'],
    }),

    /**
     * `GET /<login>/trade-history/alltrades/` — all trades for chart / aggregation.
     */
    getAllTrades: builder.query({
      query: (arg) => {
        const loginId = typeof arg === 'object' && arg !== null ? arg.loginId : arg;
        const params = typeof arg === 'object' && arg !== null ? { ...arg } : {};
        delete params.loginId;
        return {
          url: `/${encodeURIComponent(loginId)}/trade-history/alltrades/`,
          params: Object.keys(params).length ? params : undefined,
        };
      },
      providesTags: ['Trade'],
    }),

    /**
     * `GET /v2/position-history/{loginId}/export/csv/` — position history as a CSV file.
     * Takes `start_date` and `end_date`.
     */
    exportTradeHistory: builder.query({
      query: ({ loginId, ...params }) => ({
        url: `/v2/position-history/${encodeURIComponent(loginId)}/export/csv/`,
        params,
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useGetTradeHistoryQuery,
  useGetAllTradesQuery,
  useLazyGetAllTradesQuery,
  useLazyExportTradeHistoryQuery,
} = tradeHistoryApi;
